function expandElement( btnEle: HTMLElement, wrapperEle: HTMLElement, showMoreText?: string, showLessText?: string ) {
	const expendWrapper = wrapperEle.querySelector( '.js-expend-wrapper' ) as HTMLElement;
	expendWrapper && expendWrapper.classList.toggle( 'active' );
	if (!showMoreText && !showLessText) {
		return
	}
	const buttonLabel = btnEle.querySelector( 'span' ) as HTMLElement;
	btnEle.classList.toggle( 'active' );
	if ( btnEle.classList.contains( 'active' ) ) {
		buttonLabel.innerText = showLessText || '';
	} else {
		buttonLabel.innerText = showMoreText || '';
	}
}

export { expandElement };
